import React from "react";

const BackDrop = ({ ...props }) => {
	return (
		<div
			{...props}
			className="BackDrop absolute top-0 left-0 h-screen w-screen bg-black opacity-40 z-40"
		></div>
	);
};

export default BackDrop;
